import StepBar from './StepBar';

/**
 * Shown while a loader is in flight. Without it React Router renders nothing
 * during the first navigation, so the session check reads as a blank screen.
 */
export default function Opening() {
  return (
    <main className="shell">
      <div className="card">
        <StepBar left="Signing in" right="One moment" />
        <h1 className="d">
          Opening
          <br />
          the studio.
        </h1>
        <p className="sub">Establishing your session.</p>
        <div className="bar-track" aria-hidden="true">
          <i />
        </div>
      </div>
    </main>
  );
}
